query GameParamfindingResultsByEvent($eventId: UUID!) {
  allGameParamfindingResults(filter: {eventId: {equalTo: $eventId}}) {
    nodes {
      eventId
      eventStateFeed
      summary
      sport
      timestamp
    }
  }
}
